export enum SimLogStatType {
    fileCreated = 0,
    fileMoved = 1,
    ftpFileCreated = 2,
    enaioObjectCreated = 3,
    enaioObjectUpdated = 4,
    enaioObjectDeleted = 5,
    enaioUserCreated = 6,
    enaioUserUpdated = 7,
    enaioUserProfileApplied = 8,
    enaioUserSysRolesChanged = 9,
    enaioUserGroupCreated = 10,
    enaioUserGroupAssigned = 11,
    enaioUserGroupUnassigned = 12,
    enaioOrgObjectCreated = 13,
    enaioOrgObjectAttributesUpserted = 14,
    enaioOrgObjectAssigned = 15,
    enaioOrgObjectUnassigned = 16,
    enaioOrgObjectSubstituteAdded = 17,
    enaioOrgObjectSubstituteRemoved = 18,
    enaioOrgObjectSetAbsent = 19,
    databaseRowCreated = 20,
    databaseRowUpdated = 21,
    databaseRowDeleted = 22
}
export namespace SimLogStatType{
    export function getName(value: SimLogStatType): string {
        switch (value) {
            case SimLogStatType.fileCreated:
                return "fileCreated";
            case SimLogStatType.fileMoved:
                return "fileMoved";
            case SimLogStatType.ftpFileCreated:
                return "ftpFileCreated";
            case SimLogStatType.enaioObjectCreated:
                return "enaioObjectCreated";
            case SimLogStatType.enaioObjectUpdated:
                return "enaioObjectUpdated";
            case SimLogStatType.enaioObjectDeleted:
                return "enaioObjectDeleted";
            case SimLogStatType.enaioUserCreated:
                return "enaioUserCreated";
            case SimLogStatType.enaioUserUpdated:
                return "enaioUserUpdated";
            case SimLogStatType.enaioUserProfileApplied:
                return "enaioUserProfileApplied";
            case SimLogStatType.enaioUserSysRolesChanged:
                return "enaioUserSysRolesChanged";
            case SimLogStatType.enaioUserGroupCreated:
                return "enaioUserGroupCreated";
            case SimLogStatType.enaioUserGroupAssigned:
                return "enaioUserGroupAssigned";
            case SimLogStatType.enaioUserGroupUnassigned:
                return "enaioUserGroupUnassigned";
            case SimLogStatType.enaioOrgObjectCreated:
                return "enaioOrgObjectCreated";
            case SimLogStatType.enaioOrgObjectAttributesUpserted:
                return "enaioOrgObjectAttributesUpserted";
            case SimLogStatType.enaioOrgObjectAssigned:
                return "enaioOrgObjectAssigned";
            case SimLogStatType.enaioOrgObjectUnassigned:
                return "enaioOrgObjectUnassigned";
            case SimLogStatType.enaioOrgObjectSubstituteAdded:
                return "enaioOrgObjectSubstituteAdded";
            case SimLogStatType.enaioOrgObjectSubstituteRemoved:
                return "enaioOrgObjectSubstituteRemoved";
            case SimLogStatType.enaioOrgObjectSetAbsent:
                return "enaioOrgObjectSetAbsent";
            case SimLogStatType.databaseRowCreated:
                return "databaseRowCreated";
            case SimLogStatType.databaseRowUpdated:
                return "databaseRowUpdated";
            case SimLogStatType.databaseRowDeleted:
                return "databaseRowDeleted";
        }
    }

/*export namespace SimLogStatType {
    export function getText(value: SimLogStatType): string {
        switch (value) {
            case SimLogStatType.fileCreated:
                return "Dateien erstellt";
            case SimLogStatType.fileMoved:
                return "Dateien verschoben";
            case SimLogStatType.ftpFileCreated:
                return "FTP-Dateien erstellt";
            case SimLogStatType.enaioObjectCreated:
                return "enaio Objekte erstellt";
            case SimLogStatType.enaioObjectUpdated:
                return "enaio Objekte aktualisiert";
            case SimLogStatType.enaioObjectDeleted:
                return "enaio Objekte gelöscht";
            case SimLogStatType.databaseRowCreated:
                return "Datenbankzeilen erstellt";
            case SimLogStatType.databaseRowUpdated:
                return "Datenbankzeilen aktualisiert";
        }
    }
}*/


}
